export function triangleArea(base, height) {
  if (base < 0 || height < 0) throw new RangeError("base and height must be non-negative")
  return (base * height) / 2
}

export function clamp(value, minimum, maximum) {
  return Math.min(maximum, Math.max(minimum, value))
}

export function curtainShift(index, count, shear) {
  if (count < 2) throw new RangeError("count must be at least 2")
  return index === 0 ? 0 : -(index / (count - 1)) * shear
}
